module.exports = __webpack_public_path__ + "img/photo-customer-2020.1f653830.png";